<template>
  <v-autocomplete
    :items="professionAndSpecialty"
    :label="label"
    v-model="selected"
    :multiple="multi"
    item-text="HealthProfession"
    item-value="ID"
  >
  <template slot="selection" slot-scope="data">
    {{data.item.HealthProfession}} - {{data.item.Speciality}}
  </template>
  <template slot="item" slot-scope="props">
    <v-list-tile-content>
      <v-list-tile-title>
        {{props.item.HealthProfession}}
      </v-list-tile-title>
      <v-list-tile-sub-title>
        {{props.item.Speciality}}
      </v-list-tile-sub-title>
    </v-list-tile-content>
  </template>
  </v-autocomplete>
</template>
<script>
import Rules from '../validation/rules'
import { mapActions, mapGetters } from 'vuex'
const moduleNamespace = 'professionAndSpecialty'
export default {
  name: 'v-professionAndSpecialty',
  props: {
    label: '',
    value: null,
    multi: false,
    profession: '',
  },
  data() {
    return {
      selected: this.value,
      rules: Rules,
    }
  },
  created() {
    this.getProfessionAndSpecialty()
  },
  methods: {
    ...mapActions(moduleNamespace, ['getProfessionAndSpecialty']),
  },
  computed: {
    ...mapGetters(moduleNamespace, ['professionAndSpecialty']),
  },
  watch: {
    selected(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.selected = val
    },
  },
}
</script>
<style>
</style>